import React from 'react';
import Icon from 'react-icon-base';
import { any, number, oneOfType, string } from 'prop-types';

/* prettier-ignore */
const SupportInfoIcon = ({
  className, color, height, size, style, width, ...restProps
}) => (
  /* eslint-disable */
  <Icon
    className={className}
    color={color}
    height={height}
    size={size}
    style={style}
    viewBox="0 0 16 16"
    width={width}
    {...restProps}
  >
    <g>
      <path d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm.7,12.61a1.17,1.17,0,0,1-.89.37,1.15,1.15,0,0,1-.88-.37,1.3,1.3,0,0,1-.35-.92,1.33,1.33,0,0,1,.35-.93,1.18,1.18,0,0,1,.88-.37,1.21,1.21,0,0,1,.89.37,1.29,1.29,0,0,1,.36.93A1.27,1.27,0,0,1,8.7,12.61Zm1.8-6.17a2.55,2.55,0,0,1-.39.63,5.27,5.27,0,0,1-.49.57,5.08,5.08,0,0,0-.47.57,2.53,2.53,0,0,0-.35.62,1.66,1.66,0,0,0-.08.75H6.91a2.26,2.26,0,0,1,0-.87A3.12,3.12,0,0,1,7.25,8a4,4,0,0,1,.44-.61l.47-.54a3.76,3.76,0,0,0,.37-.5,1,1,0,0,0,.15-.52.81.81,0,0,0-.26-.65,1,1,0,0,0-.68-.23,1.31,1.31,0,0,0-.69.18,3.15,3.15,0,0,0-.58.47l-1.14-1A3.88,3.88,0,0,1,6.5,3.62,3.17,3.17,0,0,1,8,3.27a3.49,3.49,0,0,1,1,.14,2.23,2.23,0,0,1,.84.43,2.11,2.11,0,0,1,.56.75,2.69,2.69,0,0,1,.2,1.07A1.94,1.94,0,0,1,10.5,6.44Z"/>
    </g>
  </Icon>
  /* eslint-enable */
);

SupportInfoIcon.propTypes = {
  className: string,
  color: string,
  height: oneOfType([string, number]),
  size: oneOfType([string, number]),
  style: any, // eslint-disable-line react/forbid-prop-types
  width: oneOfType([string, number]),
};

export default SupportInfoIcon;
